import React from "react";
import "./AboutPage.css";
import Tittle from "../../Component/Tittle/Tittle";
import ImageSection from "../../Component/ImageSection/ImageSection";
import SkillsSection from "../../Component/SkillsSection/SkillsSection";
import ServicesSection from "../../Component/ServicesSection/ServicesSection";
import design from "../../img/design.svg";
import intelligence from "../../img/intelligence.svg";
import gamedev from "../../img/game-dev.svg";

function AboutPage() {
  return (
    <div className="About-page">
      <Tittle title="About Me" span="About Me" />
      <ImageSection />
      <Tittle title="My Skills" span="My Skills" />
      <div className="skils-container">
        <SkillsSection skill="Html & Css" progress="85%" width={"85%"} />
        <SkillsSection skill="ReactJS" progress="80%" width={"80%"} />
        <SkillsSection
          skill="Vanilla Javascript"
          progress="80%"
          width={"80%"}
        />
        <SkillsSection skill="C/C++" progress="60%" width={"60%"} />
        <SkillsSection skill="Git/Github" progress="75%" width={"75%"} />
        <SkillsSection skill="Linux/Shell/bash" progress="60%" width={"60%"} />
      </div>

      <Tittle title="Services" span="Services" />
      <div className="services-container">
        <ServicesSection
          image={design}
          title={"Frontend Development"}
          text={
            "Frontend development refers to the process of creating the user interface (UI) and user experience (UX) of a website or application. It involves writing code using web technologies such as HTML, CSS, and JavaScript to build the visual and interactive elements that users see and interact with in their browsers."
          }
        />
        <ServicesSection
          image={intelligence}
          title={"Backend Developement"}
          text={
            "Backend development refers to the process of building and maintaining the server-side components of a web or mobile application. It involves creating the logic, database management, and APIs (Application Programming Interfaces) that allow the frontend (client-side) and the backend to communicate with each other."
          }
        />
        <ServicesSection
          image={gamedev}
          title={"Forex Trading"}
          text={
            "Forex trading, also known as foreign exchange trading or currency trading, is the process of buying and selling currencies on the foreign exchange market. It is the largest and most liquid financial market in the world, with trillions of dollars being traded daily."
          }
        />
      </div>
    </div>
  );
}

export default AboutPage;
